import React, { useState } from 'react';
import MfaResult from '../../../models/MfaResult';
import { sleep } from '../../../utils';
import { Button } from '../../core/button';
import { Field } from '../../core/field';
import styles from '../login.module.scss';
import { loginUsernamePassword } from './service';
import Cookies from 'js-cookie';
import Notification from '../../core/notification';

type Props = {
  onMfaRequired: (metadata: MfaResult) => void;
  onAuthorized: () => void;
}

export const LoginForm: React.FC<Props> = ({ onMfaRequired, onAuthorized }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const [error, setError] = useState('');

  async function submit() {
    if (busy) {
      return;
    }
    setBusy(true);

    let error = null;

    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        await loginUsernamePassword(username, password);
        error = null;
        break;
      } catch (e) {
        error = e;
        console.error(e);

        if (e.message === 'mfaRequiredError') {
          if (e.credentials?.mfaToken) {
            Cookies.set('s2_mfatoken', e.credentials.mfaToken);
          }

          onMfaRequired({
            credentials: e.credentials,
            emailRecipient: e.mfaEmailRecipient,
            smsRecipient: e.mfaSmsRecipient,
            smsSkipped: e.mfaSmsSkipped
          });
          break;
        } else if (e.status === 401) {
          Notification.show('Kontrollera inloggning');
          break;
        }

        await sleep(2500);
      }
    }

    if (!error) {
      onAuthorized();
    }

    setBusy(false);
  }

  return (
    <form
      onSubmit={e => {
        submit();
        e.preventDefault();
        return false;
      }}
      className={styles.login}>

      <fieldset>
        <Field
          label="Användarnamn / epost"
          value={username}
          onTextValueChange={setUsername} />

        <Field
          label="Lösenord"
          value={password}
          onTextValueChange={setPassword}
          type="password" />
      </fieldset>

      <Button busy={busy} type="submit" weight="primary">
        Logga in
      </Button>
    </form>
  );
}